import React, { useState } from 'react';
import { ChevronDown, Star, CheckCircle2 } from 'lucide-react';
import { SectionReveal, SectionHeading } from './Shared';
import { motion, AnimatePresence } from 'framer-motion';
export const Trust = () => {
  const whyChoose = ['Formación estructurada.', 'Material práctico y profesional.', 'Recursos complementarios.', 'Diseño visual premium.', 'Miles de estudiantes.', 'Actualización constante.', 'Enfoque de aplicación real.'];
  const testimonials = [{
    name: 'María Laura G.',
    location: 'Mendoza',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop',
    text: 'Siempre sentí una conexión especial pero no sabía cómo canalizarla. Esta formación me dio la estructura y la confianza que necesitaba para abrir mis propios registros y entender mi camino.'
  }, {
    name: 'Sofía R.',
    location: 'Rosario',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop',
    text: 'La claridad de los módulos es increíble. Pude hacer mi primera lectura a otra persona siguiendo la guía profesional y los resultados fueron profundamente sanadores. Totalmente recomendado.'
  }, {
    name: 'Carolina M.',
    location: 'Córdoba',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=200&auto=format&fit=crop',
    text: 'Buscaba respuestas personales y encontré una herramienta para toda la vida. El material es hermoso, súper completo y el hecho de que sea a mi propio ritmo me permitió integrarlo perfecto a mi rutina.'
  }];
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. La formación está diseñada para comenzar desde cero.'
  }, {
    q: '¿Es un curso con clases en vivo?',
    a: 'No. Es una formación digital autodidacta.'
  }, {
    q: '¿Recibo certificado?',
    a: 'Sí. Incluye certificado digital.'
  }, {
    q: '¿Puedo descargar el material?',
    a: 'Sí. Las veces que quieras.'
  }, {
    q: '¿El acceso vence?',
    a: 'No. El acceso es de por vida.'
  }, {
    q: '¿Puedo utilizarlo para ayudar a otras personas?',
    a: 'Sí. La formación incluye herramientas para desarrollar lecturas profesionales.'
  }];
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <>
      {/* SECCIÓN 8: ¿POR QUÉ ELEGIR ACADEMIA HOLÍSTICA ARGENTINA? */}
      <SectionReveal className="bg-celestial-800/30" data-id="element-218">
        <div className="container mx-auto px-6 max-w-5xl" data-id="element-219">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-220">
            <div data-id="element-221">
              <h2 className="text-3xl md:text-4xl font-serif text-gold-light mb-6 leading-tight" data-id="element-222">
                ¿Por qué elegir Academia Holística Argentina?
              </h2>
              <div className="w-16 h-1 bg-gold rounded-full mb-8" data-id="element-223" />
              <p className="text-indigo-100/80 mb-8 font-light" data-id="element-224">
                Nos dedicamos a brindar formaciones de excelencia, combinando la
                profundidad espiritual con una estructura pedagógica profesional
                y accesible.
              </p>
            </div>

            <div className="bg-celestial-900/60 backdrop-blur-md border border-gold/20 rounded-2xl p-8" data-id="element-225">
              <ul className="space-y-4" data-id="element-226">
                {whyChoose.map((item, idx) => <li key={idx} className="flex items-center space-x-3" data-id="element-227">
                    <CheckCircle2 className="w-5 h-5 text-gold flex-shrink-0" data-id="element-228" />
                    <span className="text-indigo-100/90" data-id="element-229">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </SectionReveal>

      {/* SECCIÓN 9: TESTIMONIOS */}
      <SectionReveal data-id="element-230">
        <div className="container mx-auto px-6 max-w-6xl" data-id="element-231">
          <SectionHeading title="Lo Que Nuestros Estudiantes Están Logrando" data-id="element-232" />

          <div className="grid md:grid-cols-3 gap-8" data-id="element-233">
            {testimonials.map((test, idx) => <div key={idx} className="bg-celestial-800/40 border border-gold/10 rounded-2xl p-8 relative mt-8" data-id="element-234">
                <div className="absolute -top-10 left-1/2 -translate-x-1/2" data-id="element-235">
                  <div className="w-20 h-20 rounded-full border-2 border-gold p-1 bg-celestial-900" data-id="element-236">
                    <img src={test.image} alt={test.name} className="w-full h-full object-cover rounded-full" data-id="element-237" />
                  </div>
                </div>

                <div className="flex justify-center space-x-1 mt-10 mb-6" data-id="element-238">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-239" />)}
                </div>

                <p className="text-indigo-100/80 text-center italic mb-6 font-light" data-id="element-240">
                  "{test.text}"
                </p>

                <div className="text-center" data-id="element-241">
                  <p className="text-gold-light font-serif font-medium" data-id="element-242">
                    {test.name}
                  </p>
                  <p className="text-xs text-indigo-100/50 uppercase tracking-wider mt-1" data-id="element-243">
                    {test.location}, Argentina
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </SectionReveal>

      {/* SECCIÓN 10: PREGUNTAS FRECUENTES */}
      <SectionReveal className="bg-celestial-800/20" data-id="element-244">
        <div className="container mx-auto px-6 max-w-3xl" data-id="element-245">
          <SectionHeading title="Preguntas Frecuentes" data-id="element-246" />

          <div className="space-y-4" data-id="element-247">
            {faqs.map((faq, idx) => <div key={idx} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openFaq === idx ? 'border-gold/40 bg-celestial-800/60' : 'border-gold/10 bg-celestial-900/40 hover:border-gold/20'}`} data-id="element-248">
                <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-249">
                  <span className="font-medium text-gold-light pr-8" data-id="element-250">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 flex-shrink-0 ${openFaq === idx ? 'rotate-180' : ''}`} data-id="element-251" />
                </button>

                <AnimatePresence data-id="element-252">
                  {openFaq === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-253">
                      <div className="px-6 pb-5 text-indigo-100/80 font-light border-t border-gold/10 pt-4" data-id="element-254">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </SectionReveal>
    </>;
};